import { useTheme } from "@mui/material";
import type { FC } from "react";
import { Navigate, useParams } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { PaperworkAddFlow } from "web_myplann/Profile/Components/Paperwork/PaperworkAddFlow";
import { PAPERWORK_DOC_TYPES } from "web_myplann/Profile/Constants/paperworkDocTypes";
import { usePaperworkDocument } from "web_myplann/Profile/Hooks/usePaperworkDocument";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

export const PaperworkFormPage: FC = () => {
	const { palette } = useTheme();
	const { t } = useResource();
	const { type, id } = useParams();
	const docType = PAPERWORK_DOC_TYPES.find((item) => item.id === type);
	const { document, isLoading } = usePaperworkDocument(id);

	if (!docType) {
		return (
			<Navigate
				to={
					id
						? AppRouting.MyPlann.Profile.PaperworkEdit.path(id)
						: AppRouting.MyPlann.Profile.PaperworkAdd.path()
				}
				replace
			/>
		);
	}

	if (id) {
		if (isLoading) {
			return (
				<MyPlannLayout
					disableContentPadding
					bgColor={palette.grey[50]}
					topBar={
						<NavigationHeader
							title={t(Resources.Paperwork.Upload.updateTitle)}
							bgColor={palette.background.appBar}
							defaultRoute={AppRouting.MyPlann.Profile.Paperwork.path()}
							alwaysUseDefaultRoute
						/>
					}
				>
					<MyPlannLoading />
				</MyPlannLayout>
			);
		}

		if (!document) {
			return (
				<Navigate to={AppRouting.MyPlann.Profile.Paperwork.path()} replace />
			);
		}
	}

	return <PaperworkAddFlow type={docType} document={document} />;
};
